import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  margin-top: 10px;
`;
